(function () {
    'use strict';
    angular
        .module('tikonApp')
        .factory('AgentRequest', AgentRequest);

    AgentRequest.$inject = ['$resource', 'DateUtils'];

    function AgentRequest($resource, DateUtils) {
        var resourceUrl = 'api/agent-requests/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.createDate = DateUtils.convertDateTimeFromServer(data.createDate);
                        data.replyDate = DateUtils.convertDateTimeFromServer(data.replyDate);
                    }
                    return data;
                }
            },
            'update': {method: 'PUT'}
        });
    }
})();
